module.exports = __webpack_public_path__ + "static/media/signage-indoor-img2.8a5155fb.jpg";